import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {LAWYER} from '../../dictionaries';

class TabBar extends React.Component {
    constructor(props) {
        super(props);
        this.tabBarOptions = [
            {
                key: '/tgIm',
                title: '消息',
                icon: '/static/images/tgTabBarIcons/message.png',
                activeIcon: '/static/images/tgTabBarIcons/message_active.png',
                path: '/tgIm',
            },
            {
                key: '/calendar',
                title: '日程',
                icon: '/static/images/calendar.png',
                activeIcon: '/static/images/calendarBlock.png',
                path: '/calendar',
                state: {type: LAWYER}
            },
            {
                key: '/my',
                title: '我的',
                icon: '/static/images/tgTabBarIcons/my.png',
                activeIcon: '/static/images/tgTabBarIcons/my_active.png',
                path: '/my',
            },
        ];
    }

    // 切换底部导航
    switchTabBar = v => {
        const {path, state} = v;
        const {appVersion} = this.props;
        const curPath = this.props.location.pathname;
        if (path === curPath) return;
        if (appVersion >= '9.5.0' && path === '/tgIm') {
            window.location.href = 'click://platform-clearunreadmsg';
            this.props.history.push(path);
        }
        this.props.history.push({
            pathname: path,
            state
        });
    };

    render() {
        const curActivePath = this.props.location.pathname;
        return (
            <div className="TabBarBox">
                <div className="tab-bar-wrap">
                    {this.tabBarOptions.map((v, i) => {
                        const isActive = curActivePath === v.key;
                        const ActiveImg = (
                            <img
                                className="tab-bar-icon"
                                src={v.activeIcon}
                                alt=""
                            />
                        );
                        const Img = (
                            <img className="tab-bar-icon" src={v.icon} alt=""/>
                        );

                        return (
                            <div
                                key={i}
                                className="tab-bar-item"
                                onClick={() => {
                                    this.switchTabBar(v);
                                }}
                            >
                                {isActive ? ActiveImg : Img}
                                <span
                                    className={`tab-bar-title ${
                                        isActive ? 'active' : ''
                                    }`}
                                >
                                    {v.title}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default connect(state => {
    return {
        appVersion: state.getPhoneToken.appVersion
    }
}, null)(withRouter(TabBar));
